/* @flow */
import * as React from 'react';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import RankingPage from '../../common/RankingPage';

type Props = {
  goBack: Function,
};

function SushiAdvancedRankingPage(props: Props) {
  const { goBack } = props;
  return <RankingPage kind="sushi-a" onNextClick={goBack} />;
}

const dispatchToProps = dispatch => ({
  goBack: () => dispatch(push('/sushi-a/fields?skip_intro=1')),
});

const SushiAdvancedRankingPageContainer = connect<Props, {||}, _, _, _, _>(
  null,
  dispatchToProps
)(SushiAdvancedRankingPage);
export default SushiAdvancedRankingPageContainer;
